import type { PatientsData } from '@/shared/lib/types/patients';
import { create } from 'zustand';

type StarredPatientStore = {
  starredPatients: PatientsData[];
  addStarredPatient: (patient: PatientsData) => void;
  removeStarredPatient: (truentityId: string) => void;
  isPatientStarred: (truentityId: string) => boolean;
  setStarredPatients: (patients: PatientsData[]) => void;
  clearStarredPatients: () => void;
};

export const useStarredPatientStore = create<StarredPatientStore>((set, get) => ({
  starredPatients: [],

  addStarredPatient: (patient: PatientsData) => {
    set(state => {
      // Check if patient is already starred to avoid duplicates
      if (state.starredPatients.some(p => p.truentityId === patient.truentityId)) {
        return state;
      }
      return {
        starredPatients: [...state.starredPatients, patient]
      };
    });
  },

  removeStarredPatient: (truentityId: string) => {
    set(state => ({
      starredPatients: state.starredPatients.filter(patient => patient.truentityId !== truentityId)
    }));
  },

  isPatientStarred: (truentityId: string) => {
    return get().starredPatients.some(patient => patient.truentityId === truentityId);
  },

  setStarredPatients: (patients: PatientsData[]) => {
    set({ starredPatients: patients });
  },

  clearStarredPatients: () => {
    set({ starredPatients: [] });
  }
}));
